export default __webpack_public_path__ + "static/media/Close.c1baa1b1.svg";